// extracted by mini-css-extract-plugin
export var activeDot = "_66-c";
export var buttonContainer = "_66-9";
export var channelButton = "_66-a";
export var clickable = "_66-d";
export var content = "_66-0";
export var contentFull = "_66-2";
export var contentThird = "_66-1";
export var contentWrapper = "_66-7";
export var description = "_66-5";
export var heightShort = "_66-f";
export var image = "_66-3";
export var imageContainer = "_66-4";
export var selectButton = "_66-e";
export var spinnerContainer = "_66-b";
export var titleContent = "_66-8";
export var titleWrapper = "_66-6";